// extracted by mini-css-extract-plugin
module.exports = {"ProductCard":"card_ProductCard__DoTUQ"};